import { render, staticRenderFns } from "./updateDeleteBtnCellRenderer.vue?vue&type=template&id=24e8ab98&"
import script from "./updateDeleteBtnCellRenderer.vue?vue&type=script&lang=js&"
export * from "./updateDeleteBtnCellRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports